export function consultaB() {
    let obtenido = false
    let resp
    let b = typeof localStorage != 'undefined'?localStorage.getItem('b'):'' // valido que el localStorage esté disponible
    if (b != '' && b != 'null' && b != undefined && b != null) { //si se obtiene un valor, se retorna ese parámetro
        obtenido = true
        resp = b
    }else{ //si no se obtiene valor del localStorage, se hace la búsqueda del parámetro en la url
        let params = new URLSearchParams(location.search);
        let id_back = params.get('b');
        if (id_back!= '' && id_back != null && id_back!= undefined) { //manejo especial para cuando se registra el serviceWorker
            obtenido = true
            resp = id_back
        }
    }        
    if (obtenido) { //Si se obtuvo el valor, se guarda en el localStorage, se envía a la db local y se retorna el valor
        try {localStorage.setItem('b',resp)} catch (error) {}    
        try {sessionStorage.setItem('b',resp)} catch (error) {}    
        return resp
    }else{
        return null
    }
}